// extracted by mini-css-extract-plugin
export default {"container":"privacy_container__1QPy5","dark":"privacy_dark__pmqQV"};